import {
    ButtonIcon,
    ClanName,
    DivTooltip,
    Menu,
    Spinner,
    Tooltip,
    TooltipBody,
    TooltipClan,
    TooltipFooter
} from '@wg/wows-react-uikit'
import classNames from 'classnames'
import { ClanRec2SettingsIsEnabled, ClanRecSettingsIsEnabled } from 'helpers/common'
import React from 'react'
import { translate } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import {
    renameSpinnerAnimationEnterDuration,
    renameSpinnerAnimationLeaveDuration,
    renameSpinnerFadeEnterDuration,
    renameSpinnerFadeLeaveDuration
} from '../../../helpers/csstimes'
import { t } from '../../../helpers/localization'
import { hasPermission, permissions } from '../../../roles'
import settings from '../../../settings'
import { ClanDescriptionButtonTooltip } from '../../../tooltips'
import OwnClanLevelIcon from './OwnClanLevelIcon/OwnClanLevelIcon'
import styles from './OwnClanTitle.scss'

export type IProps = {
    clanName: string,
    hasClanDescription: boolean,
    clanColor: string,
    clanTag: string,
    needMenu: boolean,

    accumulativeClanResource: number,
    allBonusesActivated: boolean,
    clanLevel: number,
    roleName: string,
    isRenameInProcess: boolean,

    onDescriptionEditClick: () => void,
    onNameEditClick: () => void,
    onOldRecommendationsClanSettingsClick: () => void,
    onRecommendationsClanSettingsClick: () => void,
    onLeaveClick: () => void,
    onRulesDialogClick: (content: any) => void,
    onClanDescriptionClick: () => void,
    clanRulesContent: any,
}

export type IState = {
    isMenuActive: boolean
}

class OwnClanTitle extends React.PureComponent<IProps, IState> {

    state = {
        isMenuActive: false,
    }

    getMenuCallbacks = (arg) => {
        const menuCallbacks = {
            descriptionEdit: this.props.onDescriptionEditClick,
            nameEdit: this.props.onNameEditClick,
            oldClanSettings: this.props.onOldRecommendationsClanSettingsClick,
            clanSettings: this.props.onRecommendationsClanSettingsClick,
            leaveClan: this.props.onLeaveClick,
            rulesDialog: this.onRulesDialogClick,
        }

        menuCallbacks[arg]()
    }

    getMenuItems() {

        let items = [
            {
                value: 'nameEdit',
                content: t('Изменить тег и название'),
                permissionRequired: permissions.RENAME_CLAN,
                isDisabled: false,
            },
        ]

        if (ClanRecSettingsIsEnabled) {
            items = items.concat([
                {
                    value: 'descriptionEdit',
                    content: (this.props.hasClanDescription ? t('Изменить описание') : t('Добавить описание')),
                    permissionRequired: permissions.CHANGE_SETTINGS,
                    isDisabled: false,
                },
                {
                    value: 'oldClanSettings',
                    content: t('Игровые предпочтения клана'),
                    permissionRequired: permissions.CHANGE_SETTINGS,
                    isDisabled: !settings.recommendations.isEnabled,
                },
            ])
        }

        if (ClanRec2SettingsIsEnabled) {
            items.push({
                value: 'clanSettings',
                content: t('Изменить требования клана'),
                permissionRequired: permissions.CHANGE_SETTINGS,
                isDisabled: !settings.clanrec2.isEnabled,
            })
        }

        items = items.concat([
            {
                value: 'descriptionEdit',
                content: (this.props.hasClanDescription ? t('Изменить описание') : t('Добавить описание')),
                permissionRequired: permissions.CHANGE_SETTINGS,
                isDisabled: false,
            },
            {
                value: 'rulesDialog',
                content: t('Правила кланов'),
                isDisabled: false,
            },
            {
                value: 'leaveClan',
                content: t('Покинуть клан'),
                isDisabled: false,
            },
        ])
        return items
    }

    onRulesDialogClick = () => {
        const content = this.props.clanRulesContent

        this.props.onRulesDialogClick(content)
    }

    onMenuBlur = () => {
        this.setState({
            isMenuActive: false,
        })
    }

    onMenuToggled = (isMenuActive) => {
        this.setState({
            isMenuActive: isMenuActive,
        })
    }

    renderMenuWrapper(onItemChange, child) {
        let menuItems = this.getMenuItems().filter((item) => {
            return !item.permissionRequired ||
                hasPermission(this.props.roleName, item.permissionRequired) &&
                !item.isDisabled
        })
        return (
            <Menu
                itemSelected={''}
                items={menuItems}
                onItemChange={onItemChange}
                onMenuBlur={this.onMenuBlur}
                onMenuToggled={this.onMenuToggled}
            >
                {child}
            </Menu>
        )
    }

    renderTitleElement() {
        const clanNameTooltipId = `clan-name-tooltip-${this.props.clanTag}`
        const clanNameTooltipContent = this.props.needMenu && !this.state.isMenuActive ? (
            <Tooltip id={clanNameTooltipId}>
                <TooltipBody>
                    <TooltipClan
                        clanTag={this.props.clanTag}
                        clanColor={this.props.clanColor}
                        clanName={this.props.clanName}
                        t={t}
                    />
                </TooltipBody>
                <TooltipFooter mouseIcon="left">
                    {t('Выбрать действие с кланом')}
                </TooltipFooter>
            </Tooltip>
        ) : null

        return (
            <DivTooltip
                className={styles.title}
                tooltipBody={clanNameTooltipContent}
            >
                <ClanName
                    clanColor={this.props.clanColor}
                    clanTag={this.props.clanTag}
                    clanName={this.props.clanName}
                />
            </DivTooltip>
        )
    }

    render() {
        let displayElement = this.renderTitleElement()
        if (this.props.needMenu) {
            displayElement = this.renderMenuWrapper(this.getMenuCallbacks, displayElement)
        }

        const spinner = this.props.isRenameInProcess ? (
            <ReactCSSTransitionGroup
                component="div"
                transitionName="rename-spinner-fade"
                transitionEnter={true}
                transitionAppear={false}
                transitionEnterTimeout={renameSpinnerAnimationEnterDuration}
                transitionLeaveTimeout={renameSpinnerAnimationLeaveDuration}
            >
                <div className={styles.spinner}>
                    <Spinner label={t('Переименовываем клан')} />
                </div>
            </ReactCSSTransitionGroup>
        ) : null

        let clanDescriptionButton = null
        if (this.props.hasClanDescription || hasPermission(this.props.roleName, permissions.CHANGE_SETTINGS)) {
            clanDescriptionButton = (
                <ButtonIcon
                    type="clan-info"
                    tooltipContent={(<ClanDescriptionButtonTooltip />)}
                    onClick={this.props.hasClanDescription ? this.props.onClanDescriptionClick : this.props.onDescriptionEditClick} />
            )
        }

        const clanLevel = settings.supply.isEnabled ? (
            <OwnClanLevelIcon
                clanLevel={this.props.clanLevel}
                accumulativeClanResource={this.props.accumulativeClanResource}
                allBonusesActivated={this.props.allBonusesActivated}
            />
        ) : null

        const classNameBase = classNames(styles.base, {
            [styles.isNavalBaseEnabled]: settings.supply.isEnabled,
        })

        return (
            <div className={classNameBase}>
                <div className={styles.clanName}>
                    {displayElement}
                </div>
                <div className={styles.clanDescription}>{clanDescriptionButton}</div>
                <ReactCSSTransitionGroup
                    component="div"
                    transitionName="rename-spinner-animation"
                    transitionEnter={true}
                    transitionAppear={false}
                    transitionEnterTimeout={renameSpinnerFadeEnterDuration}
                    transitionLeaveTimeout={renameSpinnerFadeLeaveDuration}
                >
                </ReactCSSTransitionGroup>

                {spinner}
            </div>
        )
    }
}

export default translate()(OwnClanTitle)